export const GetCollaboratorsRepository = Symbol.for('GetCollaboratorsRepository');
